<template>
    <div class="tab-content">
        <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">
            <el-tab-pane :disabled="!engagementPermission.viewDetail" :label="$t('e_tab_info_detail')" name="first">
                <el-card v-if="projectInfo" class="box-card card panel">

                    <el-row :gutter="20" class="info-title-color">
                      <el-col :span="11">
                        <div class="title">{{$t('e_tab_info_detail_engagement')}}</div>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('e_tab_info_detail_createdBy')}}
                          </el-col>
                          <el-col :span="14" class="info-color">
                            <el-tooltip placement="top">
                              <div slot="content">
                                <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                              </div>
                              <span class="pointer" @mouseenter="getUserInfo(projectInfo.creatorUser.id)" v-if="projectInfo.creatorUser">{{projectInfo.creatorUser.user.fullName}}</span>
                              <!--<span class="pointer" v-if="projectInfo.creatorUser" @mouseenter="getUserInfo(projectInfo.creatorUser.id)">{{projectInfo.creatorUser.user.fullName}}</span>-->
                            </el-tooltip>
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/no.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('e_tab_info_detail_engagementNo')}}:
                          </el-col>
                          <el-col :span="14">
                            <el-row class="info-color">
                              <el-col :span="24">{{projectInfo.code}}</el-col>
                            </el-row>
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('e_tab_info_detail_engagementName')}}:
                          </el-col>
                          <el-col :span="14">
                            <el-row class="info-color">
                              <el-col :span="24">
                                <strong>{{projectInfo.name}}</strong>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                            <span>{{$t('modal_type')}}:</span>
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{projectInfo.type.name}}
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                            <span>{{$t('modal_region')}}:</span>
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{projectInfo.region.name}}
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                            <span>{{$t('modal_email')}}:</span>
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{projectInfo.email}}
                          </el-col>
                        </el-row>

                        <el-row v-if="projectInfo.addressData.isAddressAssigned" style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/globe.svg" width="20px;" style="margin-right: 5px;">
                            <span>{{$t('modal_eAddress')}}:</span>
                          </el-col>
                          <el-col :span="14" class="info-color">
                            <el-link @click="openMap()" type="primary">{{projectInfo.addressData.countryName + ', ' + projectInfo.addressData.stateName + ', ' + projectInfo.addressData.cityName + ', ' + projectInfo.addressData.address + ', ' + projectInfo.addressData.address2 + ', ' + projectInfo.addressData.address3}}</el-link>
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/dollar-sign.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('modal_billingMethod')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.bill == 0">{{$t('modal_billing_single')}}</span>
                              <span v-if="projectInfo.bill == 1">{{$t('modal_billing_progress')}}</span>
                              <span v-if="projectInfo.bill == 2">{{$t('modal_billing_notBillable')}}</span>
                            </el-col>
                        </el-row>

                        <el-divider></el-divider>

                        <div class="title">{{$t('e_tab_info_detail_dates')}}</div>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('project_tab_info_detail_createdOn')}}
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{moment(projectInfo.createDate * 1000).format("D MMM YY")}}
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('project_tab_info_detail_startDate')}}
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{projectInfo.plannedStartDate ? moment(projectInfo.plannedStartDate).format("D MMM YY, h:mm a") : 'Not Set'}}
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('project_tab_info_detail_reviewDate')}}
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{projectInfo.reviewDate ? moment(projectInfo.reviewDate).format("D MMM YY, h:mm a") : 'Not Set'}}
                          </el-col>
                        </el-row>

                        <el-divider></el-divider>

                        <div class="title">{{$t('e_tab_info_detail_bu')}}</div>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('modal_engagementOwner')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.owner">{{projectInfo.owner}}</span>
                            </el-col>
                        </el-row>

                        <el-row  style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('e_tab_info_detail_eManager')}}
                          </el-col>
                          <el-col :span="14" class="info-color">
                            <el-tooltip placement="top">
                              <div slot="content">
                                <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                              </div>
                              <span class="pointer" v-if="projectInfo.managerUser" @mouseenter="getUserInfo(projectInfo.managerUser.id)">{{projectInfo.managerUser.user.fullName}}</span>
                              <!--<span class="pointer" v-if="projectInfo.creatorUser" @mouseenter="getUserInfo(projectInfo.creatorUser.id)">{{projectInfo.creatorUser.user.fullName}}</span>-->
                            </el-tooltip>
                          </el-col>
                        </el-row>

                        <!-- <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/layers.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('modal_stage')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.stage">{{projectInfo.stage.name}}</span>
                            </el-col>
                        </el-row> -->

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('modal_engagementBUs')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.buNames">{{projectInfo.buNames}}</span>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('modal_BUManagers')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.busManagers">{{projectInfo.busManagers}}</span>
                            </el-col>
                        </el-row>

                        <el-divider></el-divider>

                        <div class="title">{{$t('e_tab_info_detail_notifications')}}</div>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('modal_BUManagersNotified')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.notifyData.notifyBUManagers">{{$t('general_yes')}}</span>
                              <span v-else>{{$t('general_no')}}</span>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('modal_clientsNotified')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.notifyData.notifyClients">{{$t('general_yes')}}</span>
                              <span v-else>{{$t('general_no')}}</span>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('modal_vendorsNotified')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.notifyData.notifyVendors">{{$t('general_yes')}}</span>
                              <span v-else>{{$t('general_no')}}</span>
                            </el-col>
                        </el-row>

                        <el-divider></el-divider>

                      </el-col>
                      <el-col :span="13">
                        <!-- <div class="title" style="text-align: center;">{{$t('e_tab_info_detail_progress')}}</div> -->

                        <el-row type="flex" justify="end">
                          <el-col :span="8">
                            <br>
                            <!-- <el-row>
                              <el-col :span="24" style="margin-bottom: 15px;">
                                <el-tooltip class="item" effect="dark" content="Stage" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="projectInfo.companyStage.name"></el-tag>
                                </el-tooltip>
                              </el-col>
                              <el-col :span="24" style="margin-bottom: 15px;">
                                <el-tooltip class="item" effect="dark" content="Status" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="projectInfo.projectStatus.name"></el-tag>
                                </el-tooltip>
                              </el-col>
                              <el-col :span="24">
                                <el-tooltip class="item" effect="dark" content="Priority" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="projectInfo.priority.name"></el-tag>
                                </el-tooltip>
                              </el-col>
                            </el-row> -->
                            <el-row>
                              <el-col :span="24" style="margin-bottom: 15px;">
                                <div style="margin-left: 45px;">Stage</div>
                                <el-tooltip class="item" effect="dark" content="Phase" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="projectInfo.stage.name"></el-tag>
                                </el-tooltip>
                              </el-col>
                              <el-col :span="24" style="margin-bottom: 15px;">
                                <div style="margin-left: 45px;">Status</div>
                                <el-tooltip class="item" effect="dark" content="Status" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="$t(projectInfo.status.translationKey)"></el-tag>
                                </el-tooltip>
                              </el-col>
                              <el-col :span="24">
                                <div style="margin-left: 45px;">Priority</div>
                                <el-tooltip class="item" effect="dark" content="Priority" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="$t(projectInfo.priority.translationKey)"></el-tag>
                                </el-tooltip>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="8">
                            <div class="title">{{$t('e_tab_info_detail_progress')}}</div>

                            <!-- <el-progress type="dashboard" :percentage="Math.round(projectInfo.progress)" :color="colors"></el-progress> -->
                            <div style="margin-bottom: 15px;">
                                <!-- <div class="circle">
                                    <div class="circle_number">{{projectInfo.doneChildTasksCount}}/{{projectInfo.childTasksCount}}</div>
                                </div> {{$t('general_done')}}/{{$t('general_subTask')}} -->

                                <el-row :gutter="20">
                                  <el-col :span="24" :offset="0">{{projectInfo.childTasksCount}} - {{$t('general_subTask')}}</el-col>
                                </el-row>

                                <el-row :gutter="20">
                                  <el-col :span="24" :offset="0">{{projectInfo.fullProgressTasksCount}} - 100%</el-col>
                                </el-row>

                                <el-row :gutter="20">
                                  <el-col :span="24" :offset="0">{{projectInfo.doneChildTasksCount}} - {{$t('general_done')}}</el-col>
                                </el-row>

                                <!-- <div>{{$t('general_done')}} ({{projectInfo.doneChildTasksCount}}) / {{$t('general_subTask')}} ({{projectInfo.childTasksCount}})</div> -->
                            </div>
                            <div>
                                <!-- <div class="circle">
                                    <div class="circle_number">{{projectInfo.fullProgressTasksCount}}/{{projectInfo.childTasksCount}}</div>
                                </div> 100%/{{$t('general_subTask')}} -->

                                <!-- <div>100% ({{projectInfo.fullProgressTasksCount}}) / {{$t('general_subTask')}} ({{projectInfo.childTasksCount}})</div> -->
                            </div>
                          </el-col>
                          <el-col :span="8">
                            <br>
                            <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>

                    <!-- <div class="panel__description">
                      <div class="panel__gif">
                        <img src="@/assets/img/gif.gif" width="20px;">
                      </div>
                      <el-collapse>
                        <el-collapse-item :title="$t('e_tab_info_detail_about') + ':'" name="1">
                          <div v-html="!projectInfo.description ? emtyDescription : projectInfo.description"></div>
                        </el-collapse-item>
                      </el-collapse>
                    </div> -->

                    <div class="panel__footer">
                      <div class="panel__team">

                        <el-row :gutter="20">
                          <el-col :span="14" :offset="0">
                            <div class="panel__team_title">
                              <i class="color h-center">
                                <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                <div class="title">{{$t('e_tab_info_detail_engagementTeam')}}:</div>
                                <!-- {{$t('e_tab_info_detail_engagementTeam')}}: -->
                              </i>
                            </div>
                            <div>
                              <div class="panel__team_item" v-for="item in engagementCompanyUserList" :key="item.id" >
                                <el-tooltip placement="top">
                                  <div slot="content">
                                    <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                    <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                    <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                    <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                    <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                    <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                    <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                    <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                  </div>
                                  <span @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                                </el-tooltip>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="10" :offset="0">
                            <div class="title">{{$t('e_tab_info_detail_permissions')}}:</div>
                            <div class="panel__team_item" style="margin-left: 0px; cursor: default;" v-for="item in engagementCompanyUserList" :key="item.id">
                              <div>{{item.permissionPreset}}</div>
                            </div>
                          </el-col>
                        </el-row>

                      </div>
                      <div class="panel__clients">
                        <div class="panel__team_title">
                          <i class="color h-center">
                            <img src="@/assets/img/info/client_icn.svg" width="20px;" style="margin-right: 5px;">
                            <div class="title">{{$t('e_tab_info_detail_engagementClients')}}:</div>
                            <!-- {{$t('e_tab_info_detail_engagementClients')}}: -->
                          </i>
                        </div>
                        <div>
                          <div class="panel__team_item" v-for="item in engagementCompanyClientList" :key="item.id">
                            <el-tooltip placement="top">
                              <div slot="content">
                                <span v-if="item.companyClient.name">Name: {{item.companyClient.name}}<br/></span>
                                <span v-if="item.companyClient.phone">Phone: {{item.companyClient.phone}}<br/></span>
                                <span v-if="item.companyClient.street">Location: {{item.companyClient.street}}<br/></span>
                                <span v-if="item.companyClient.email">Email: {{item.companyClient.email}}<br/></span>
                                <span v-if="item.companyClient.fax">Fax: {{item.companyClient.fax}}<br/></span>
                                <span v-if="item.companyClient.website">Website: <a :href="item.companyClient.website" target="_blank">{{item.companyClient.website}}</a><br/></span>
                                <span v-if="item.companyClient.facebook">Facebook: <a :href="item.companyClient.facebook" target="_blank">{{item.companyClient.facebook}}</a><br/></span>
                                <span v-if="item.companyClient.linkedin">Linkedin: <a :href="item.companyClient.linkedin" target="_blank">{{item.companyClient.linkedin}}</a><br/></span>
                              </div>
                              <span v-html="item.companyClient.name"></span>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                      <div class="panel__vendors">
                        <div class="panel__team_title">
                          <i class="color h-center">
                            <img src="@/assets/img/info/vendor_icn.svg" width="20px;" style="margin-right: 5px;">
                            <div class="title">{{$t('e_tab_info_detail_engagementVendors')}}:</div>
                            <!-- {{$t('e_tab_info_detail_engagementVendors')}}: -->
                          </i>
                        </div>
                        <div>
                          <div class="panel__team_item" v-for="item in engagementCompanyVendorList" :key="item.id">
                            <el-tooltip placement="top">
                              <div slot="content">
                                <span v-if="item.companyVendor.name">Name: {{item.companyVendor.name}}<br/></span>
                                <span v-if="item.companyVendor.phone">Phone: {{item.companyVendor.phone}}<br/></span>
                                <span v-if="item.companyVendor.street">Location: {{item.companyVendor.street}}<br/></span>
                                <span v-if="item.companyVendor.email">Email: {{item.companyVendor.email}}<br/></span>
                                <span v-if="item.companyVendor.fax">Fax: {{item.companyVendor.fax}}<br/></span>
                                <span v-if="item.companyVendor.website">Website: <a :href="item.companyVendor.website" target="_blank">{{item.companyVendor.website}}</a><br/></span>
                                <!-- <span v-if="item.companyVendor.facebook">Facebook: {{item.companyVendor.facebook}}<br/></span>
                                <span v-if="item.companyVendor.linkedin">Linkedin: {{item.companyVendor.linkedin}}<br/></span> -->
                              </div>
                              <span v-html="item.companyVendor.name"></span>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                    </div>

                </el-card>
            </el-tab-pane>

            <!-- about -->
            <el-tab-pane :disabled="!engagementPermission.viewAbout" :label="$t('e_tab_info_about')" name="about">
              <el-card class="box-card card panel">
                <!-- <div v-html="!projectInfo.description ? emtyDescription : projectInfo.description"></div> -->
                <about/>
              </el-card>
              <!-- (About project) -->
            </el-tab-pane>

            <!-- to do -->
            <!-- <el-tab-pane :disabled="!engagementPermission.viewToDo" :label="$t('e_tab_info_toDo')" name="toDo">
              <el-card class="box-card card panel">
                Current Service Under Development
              </el-card>
            </el-tab-pane> -->

            <!-- history -->
            <el-tab-pane :disabled="!engagementPermission.viewHistory" :label="$t('e_tab_info_history')" name="five">
              <engagementHistory/>
            </el-tab-pane>

            <!-- permissions -->
            <el-tab-pane v-if="companyLayout.permission.managePermissionEngagement" :label="$t('e_tab_info_permissions')" name="permissions">
              <engagementPermissionTab @setNewPermissions="setNewPermissions" ref="engagementPermissionTab" :permissionsList="permissionsList" :pressetsList="pressetsList"/>
            </el-tab-pane>
        </el-tabs>

      <!-- [ Modal form Project Address ] start -->
      <sweet-modal blocking ref="projectAddress" class="modal">
        <h1 class="modal__title">Engagement Address</h1>

        <iframe width="100%" height="400px" id="gmap_canvas" :src="map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
      </sweet-modal>
      <!-- [ Modal form Project Address ] end -->

<!--      <div class="book-mark-block pointer">-->
<!--        <div>-->
<!--          <div v-if="bookmarkListEngagement.info" @click="changeBookMarkEngagement(bookmarkListEngagement.info, $route.query.companyId, selectedRow.engagementId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--          <div v-else @click="changeBookMarkEngagement(bookmarkListEngagement.info, $route.query.companyId, selectedRow.engagementId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
</template>

<script>
    import axios from 'axios';
    import engagementHistory from '@/components/Engagements/engagementHistoryTab.vue'
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
    import moment from 'moment'
    // engagementPermissionTab
    import engagementPermissionTab from '@/components/Engagements/permission/engagementPermissionTab.vue'
    import about from '@/components/Engagements/about/about.vue'

    export default  {
        name: 'info-tab',
        beforeMount() {
            this.gridOptions = {};
            this.clientsColumnDefs = [
                { field: "#",
                    width: 50
                },
                { field: "name" },
                { field: "email" },
                { field: "mobile phone" }
            ];
            this.vendorsColumnDefs = [
                { field: "#",
                    width: 50
                },
                { field: "name" },
                { field: "email" },
                { field: "mobile phone" }
            ];
            this.defaultColDef = {
                resizable: false,
            };
        },
        mounted(){
            this.gridApi = this.gridOptions.api;
        },
        components: {
            SweetModal,
            engagementHistory,
            engagementPermissionTab,
            about,
        },
        props: ['engagementPermission',
            'activeInfoTab',
            'value',
            'projectInfo',
            // 'bookmarkListEngagement',
            'selectedRow',
            'companyLayout',
            'businessUnitPermission'
        ],
        computed: {

        },
        data() {
            return {
              map: '',
              newVendorList:[],
              newClientList:[],
              loadingTooltip: false,
              tooltipUser:{},
                // Project
                engagementCompanyUserList: null,
                engagementCompanyClientList: null,
                engagementCompanyVendorList: null,

                taskStatusName: '',
                taskStatusStyle: null,
                activeStar: 'el-icon-star-on',
                notActiveStar: 'el-icon-star-off',
                moment:moment,
                emtyDescription: this.$i18n.t('noDetailsProvided'),
                activeName: '',
                isActive:false,
                aboutTaskBtn: 'Open',

                //TEAM table
                gridApi: null,
                columnDefs:null,
                clientsColumnDefs:null,
                defaultColDef:null,
                rowData: [],

                colors: [
                  {color: '#e67112', percentage: 25},
                  {color: '#63B8FF', percentage: 51},
                  {color: '#63B8FF', percentage: 76},
                  {color: '#0fd641 ', percentage: 100}
                ],
              //permissions
              permissionsList: [],
              pressetsList: [],
            }
        },
        watch: {
            projectInfo: function (val) {
                this.engagementCompanyUserList = this.projectInfo.engagementCompanyUserList
                this.engagementCompanyClientList = this.projectInfo.engagementCompanyClientList
                this.engagementCompanyVendorList = this.projectInfo.engagementCompanyVendorList
            }
        },
        methods:{
          openMap() {
            let address = this.projectInfo.addressData.countryName + ',' +  this.projectInfo.addressData.stateName + ',' +  this.projectInfo.addressData.cityName
            if (this.projectInfo.addressData.address) {
              address = address + ',' + this.projectInfo.addressData.address
            }
            if (this.projectInfo.addressData.address2 > 0) {
              address = address + ',' + this.projectInfo.addressData.address2
            }
            if (this.projectInfo.addressData.address3.length > 0) {
              address = address + ',' + this.projectInfo.addressData.address3
            }
            this.map = 'https://maps.google.com/maps?q=' + address + '&t=&z=13&ie=UTF8&iwloc=&output=embed';
            this.$refs['projectAddress'].open()
          },
          getUserInfo(id){
            this.loadingTooltip = true;
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/engagements/fieldInfo?companyId=${this.$route.query.companyId}&field=companyUser&companyUserId=${id}`)
                    .then(response => {
                      console.log('hello2131231', response.data)
                      this.tooltipUser = response.data.fieldInfo.user
                      this.loadingTooltip = false
                    })
                    .catch(error => {
                      this.loadingTooltip = false
                      console.log('An error occurred:', error);
                    });
          },
          createMyList(list, personList, state) {
            console.log('list, personList, state', list, personList, state)
            const myList = []

            for (let i = 0; i < list.length; i++) {
              myList.push({ ...list[i], people: [] })
              if(state === 'vendor'){
                for (let j = 0; j < personList.length; j++) {
                  if (list[i].id === personList[j].companyVendorPerson.companyVendorId) {
                    console.log('list[i].companyVendorId', list[i].id )
                    myList[i].people.push(personList[j])
                    // personList.splice(j, 1)
                  }
                }
              }
              if(state === 'clients'){
                for (let j = 0; j < personList.length; j++) {
                  if (list[i].id === personList[j].companyClientPerson.companyClientId) {
                    myList[i].people.push(personList[j])
                    // personList.splice(j, 1)
                  }
                }
              }
            }
            console.log('myList11', myList)
            return myList
          },
          notification(title, message, type) {
            this.$notify({
              title: title,
              message: message,
              type: type
            });
          },
          // changeBookMarkEngagement(state, companyId, engagementId, taskId){
          //   let data = this.bookmarkListEngagement
          //   data.info = !this.bookmarkListEngagement.info
          //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          //   axios.post(`/api/v1/bookmarks/setEngagement?companyId=${companyId}&engagementId=${engagementId}`, data)
          //           .then(response => {
          //             if (this.bookmarkListEngagement.info) {
          //               this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
          //             } else {
          //               this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
          //             }
          //           })
          //           .catch(error => {
          //           });
          // },
          openDescriptionProject() {
            this.$refs.descriptionEngagement.open()
          },
          openDescriptionTask() {
            this.$refs.descriptionTask.open()
          },
            checkRow(){

            },
            handleClick(tab, event) {
                if(tab.name === "third"){
                    this.getProjectClients();
                }
                if(tab.name === "four"){
                    this.getProjectVendors();
                }

                // history
                if(tab.name === "five"){
                  this.$store.dispatch('getEngagementHistory')
                }

                // permissions
                if(tab.name === "permissions") {
                  this.$store.dispatch('getEngagementPermissionsList', this.$route.query.engagementId);
                  this.loadPermissionData()
                }

                if (tab.name === 'toDo') {
                  this.$store.dispatch('toDo', 'engagement')
                }

                if (tab.name === 'about') {
                  this.$store.dispatch('about', 'engagement')
                }
            },
            modalAboutTask(){
                this.isActive = !this.isActive;
                if(this.isActive){
                    this.aboutTaskBtn = 'Close'
                }else{
                    this.aboutTaskBtn = 'Open'
                }
            },
            onGridReady(params) {},
            getProjectClients(){
                this.$refs.clientsProjectGrid.put()
            },
            getProjectVendors(){
                this.$refs.vendorsProjectGrid.put()
            },
          async loadPermissionData(){
            try {
              this.permissionsList = await this.getPermissionsRulesList();

              this.pressetsList = await this.getPermisssionsPressetsList()
            } catch(err){
              console.log(err)
            }
          },
          getPermissionsRulesList(){
            return new Promise ((resolve, reject) => {
              let loader = this.$loading.show();
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                      .get(`/api/v1/permissionRules/list?permissionGroup=4`)
                      .then(response => {
                        console.log('---', response.data);
                        resolve(response.data.list);
                        loader.hide()
                      })
                      .catch(error => {
                        loader.hide();
                        console.log('An error occurred:', error);
                      });
            })
          },
          getPermisssionsPressetsList(){
            return new Promise ((resolve, reject) => {
              let loader = this.$loading.show();
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                      .get(`/api/v1/permissionPressets/list?permissionGroup=4&companyId=${this.$route.query.companyId}`)
                      .then(response => {
                        console.log('---', response.data);
                        const customPresset = {
                          companyId: 0,
                          id: 0,
                          permissionGroup: 4,
                          permissionPressetIdArr: [],
                          permissionPressetName: "customPresset"
                        };
                        response.data.list.push(customPresset);
                        resolve(response.data.list)
                        loader.hide()
                      })
                      .catch(error => {
                        loader.hide();
                        console.log('An error occurred:', error);
                      });
            })
          },
          setNewPermissions(permissions){
            this.$emit('setNewPermissions', permissions)
          }
        }
    }
</script>

<style lang="less" scoped>
    .about-task{
        display:none;
    }
    .about-task.open{
        display:block;
    }
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
        display:flex;
        align-items:center;
        font-weight:bold;
        padding:10px;
        font-size:14px;
        transition: .5s;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
    .card {
        .slot{
            margin:10px 0 0 0;
            padding-bottom:10px;
            border-bottom: 1px solid #ccc;
        }
        margin-bottom: 20px;
        .tag {
            margin-right: 5px;
        }
        &__no {
            display: flex;
            justify-content:space-between;
            /*align-items: center;*/
            font-weight: bold;
            padding-bottom: 5px;
            .name {
                margin-right: 10px;
            }
            .progress {
                flex: 1;
            }
        }
        &__name {
            font-weight: bold;
            padding-bottom: 5px;
        }
        &__task-name {
            font-size: 18px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
        }
        &__location {
            padding-top: 5px;
            padding-bottom: 5px;
        }
        &__stat {
            padding-top: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            span {
                font-weight: bold;
            }
        }
        &__by-to {
            padding-top: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            span {
                font-weight: bold;
            }
        }
        &__btn {
            align-self: flex-end;
            // padding-top: 5px;
            // padding-bottom: 5px;
            // text-align: right;
            margin-left: 10px;
        }
    }

    .panel {
      min-width: 890px;
      margin-bottom: 20px;

      i.color {
          font-style: normal;
          color: #888
        }

      // Header
      &__header {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
      }

      &__project-name {
        span {font-weight: bold;}
      }
      &__task-name {
        font-weight: bold;
        font-size: 20px;
      }
      &__progress {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 5px;
        .el-progress {
          width: 350px;
        }
      }
      &__stage {
          min-width: 70px;
      }
      &__status {
        display: flex;
        justify-content: flex-end;
      }

      // Info
      &__info {
        // border-bottom: 1px solid #EBEEF5;
        padding: 10px 0 5px 0;
        position: relative;
      }
      &__date {
        display: flex;
        margin-bottom: 5px;
      }
      &__planned {
        width: 300px;
        span {font-weight: bold;}
      }
      &__actual {
        span {font-weight: bold;}
        i {font-style: normal;}
      }
      &__by-to {
        display: flex;
      }
      &__by {
        width: 300px;
        span {font-weight: bold;}
      }
      &__to {
        span {font-weight: bold;}
      }
      &__priority {
        position: absolute;
        top: calc(50% - 10px);
        right: 0;
      }

      // Description
      &__description {
        position: relative;
        // border-bottom: 1px solid #EBEEF5;
        padding: 5px 0;
      }

      &__gif {
        position: absolute;
        top: 18px;
        left: 0;
      }

      // Footer
      &__footer {
        display: flex;
        justify-content: space-between;
        min-height: 150px;
        padding: 5px 0;
      }
      &__team {
        width: 46%;
        padding: 0 10px 0 0;
        border-right: 1px solid #EBEEF5;
        &_title {
          // font-weight: bold;
          font-size: 16px;
        }
        &_item {
          cursor: pointer;
          margin-left: 25px;
          line-height: 1.5;
          // color: #4277A6;
          color: black;
        }
      }
      &__clients {
        width: 27%;
        padding: 0 10px;
        border-right: 1px solid #EBEEF5;
        &_title {
          font-weight: bold;
        }
        &_item {
          cursor: pointer;
          margin-left: 22px;
        }
      }
      &__vendors {
        width: 27%;
        padding: 0 0 0 10px;
        &_title {
          font-weight: bold;
        }
        &_item {
          cursor: pointer;
          margin-left: 22px;
        }
      }

      // &__project-name {
      //   font-weight: bold;
      // }
      // &__task-name {
      //   font-size: 18px;
      //   padding-bottom: 5px;
      // }
      // &__location {
      //   padding-bottom: 5px;
      // }
      // &__created-by {
      //   padding-bottom: 5px;
      // }
      // &__about {
      //   padding-bottom: 5px;
      // }
      // &__by-to {
      //   padding-bottom: 5px;
      //   span {
      //     font-weight: bold;
      //   }
      // }
      // &__progress {
      //   display: flex;
      //   justify-content: space-between;
      //   align-items: center;
      //   padding-bottom: 5px;
      //   span {
      //     font-weight: bold;
      //   }
      //   .el-progress {
      //     flex-grow: 1;
      //     // width: 200px;
      //   }
      //   div {
      //     white-space: nowrap;
      //     margin-right: 10px;
      //     &:last-child {
      //       margin-right: 0;
      //     }
      //   }
      // }
      // &__date {
      //   padding-bottom: 5px;
      //   span {
      //     font-weight: bold;
      //   }
      //   i {
      //     font-style: normal;
      //   }
      // }
      // &__status {
      //   padding-bottom: 5px;
      // }
      // &__slot {
      //   padding-bottom: 5px;
      //   &:first-child {
      //     margin-top: 20px;
      //   }
      //   span {
      //     font-weight: bold;
      //   }
      // }
    }
    .vendor{
      font-weight:bold;
    }
    p {
      img {
        max-width: 100%;
      }
    }
    .title {
      color: #409EFF;
      font-weight: 500;
      text-decoration: underline;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
</style>
